class CollectionProductsGrid extends HHBaseElement {
  constructor() {
    super()

    this.$grid = this.querySelector('.product-grid .grid')
    this.$loadMoreButton = this.querySelector('.js-load-more-button')
    this.$loadMoreCount = this.querySelector(
      '.collection-grid__load-more .current-amount'
    )

    this._handleLoadMore = this._handleLoadMore.bind(this)
  }

  connectedCallback() {
    this._attachListeners()
    this._setLoadMoreListners()
  }

  get nextPageUrl() {
    return this.getAttribute('data-paginate-next')
  }

  set nextPageUrl(value) {
    return this.setAttribute('data-paginate-next', value)
  }

  get previousPageUrl() {
    return this.getAttribute('data-paginate-previous')
  }

  set previousPageUrl(value) {
    return this.setAttribute('data-paginate-previous', value)
  }

  _attachListeners() {
    this.$loadMoreButton?.addEventListener('click', this._handleLoadMore)
  }

  async _handleLoadMore(event) {
    event.preventDefault()
    try {
      if (this.loading) {
        return
      }
      this._setLoading(true)
      this.$loadMoreButton.setAttribute('disabled', true)
      const nextPage = await this._fetchPage(this.nextPageUrl)
      if (!nextPage.paginateNext) {
        this.$loadMoreButton.remove()
      }

      this._renderPage(nextPage)
    } catch (error) {
      console.error(error)
    } finally {
      this.$loadMoreButton?.removeAttribute('disabled')
      this._setLoading(false)
    }
  }

  async _fetchPage(nextUrl) {
    if (nextUrl) {
      const response = await fetch(nextUrl)
      const $page = document.createElement('div')
      $page.innerHTML = await response.text()

      const collectionGrid = $page.querySelector('collection-products-grid')
      return {
        products: $page.querySelectorAll(
          'collection-products-grid .product-grid .product-card__list-item'
        ),
        $loadMoreButton: $page.querySelector(
          'collection-products-grid .js-load-more-button'
        ),
        paginateNext: collectionGrid.nextPageUrl,
        paginatePrevious: collectionGrid.previousPageUrl,
        filterContent: $page.querySelector('[data-filters-form]'),
        mobileFilterContent: $page.querySelector(
          '[data-filter-form-submitable]'
        ),
      }
    }

    throw new Error('No More Page to Load')
  }

  _renderPage(page, reset = false) {
    this.nextPageUrl = page.paginateNext
    this.previousPageUrl = page.paginatePrevious

    if (reset) {
      this.$grid.innerHTML = ''
      for (const item of page.products) {
        this.$grid.append(item)
      }
    } else {
      this._addProductsAndCards(page.products)
    }

    this.$loadMoreCount.innerHTML = [...this.$grid.querySelectorAll('.product-card__list-item')].length

    if (page.filterContent) {
      this.$filtersForm.innerHTML = page.filterContent.innerHTML
      this.$filtersFormSubmitable.innerHTML = page.mobileFilterContent.innerHTML
    }

    if (page.products.length) {
      page.products[0].focus()
    }
  }

  _addProductsAndCards(contents = []) {
    this.$grid.append(...contents)
  }

  _setLoadMoreListners() {
    if (this.$loadMoreButton) {
      this.$loadMoreButton.removeEventListener('click', this._handleLoadMore)
      this.$loadMoreButton.addEventListener('click', this._handleLoadMore)
    }

    this.$loadMoreContainer = this.querySelector('.collection-grid__load-more')
  }

  _setLoading(loading) {
    this.loading = loading
  }
}

window.customElements.define('collection-products-grid', CollectionProductsGrid)
